export const sanitizeErrorMessage = (errorMessage: string | null | undefined): string => {
  if (!errorMessage) {
    return 'Ocorreu um erro ao processar a solicitação. Tente novamente.';
  }
  
  const message = String(errorMessage);
  
  if (message.includes('update `') || 
      message.includes('INSERT INTO') || 
      message.includes('DELETE FROM') || 
      message.includes('SELECT') ||
      message.includes('ALTER TABLE') ||
      message.includes('CREATE TABLE') ||
      message.includes('DROP TABLE')) {
    console.error('Mensagem de erro contém query SQL:', message);
    return 'Ocorreu um erro ao processar os dados. Tente novamente.';
  }
  
  if (message.includes('Unknown column') || 
      message.includes('Table') || 
      message.includes('doesn\'t exist') ||
      message.includes('ER_')) {
    console.error('Mensagem de erro contém informações de banco de dados:', message);
    return 'Ocorreu um erro ao processar os dados. Tente novamente.';
  }
  
  if (message.includes('Falha ao excluir partes')) {
    console.error('Erro ao excluir partes:', message);
    return 'Ocorreu um erro ao atualizar as partes envolvidas. Tente novamente.';
  }
  
  if (message.includes('Falha ao salvar')) {
    console.error('Erro ao salvar:', message);
    return 'Ocorreu um erro ao salvar os dados. Tente novamente.';
  }
  
  if (message.includes('Network Error') || 
      message.includes('timeout') || 
      message.includes('ECONNREFUSED')) {
    console.error('Erro de rede:', message);
    return 'Erro de conexão. Verifique sua internet e tente novamente.';
  }
  
  if (message.length > 200) {
    console.error('Mensagem de erro muito longa:', message);
    return 'Ocorreu um erro ao processar a solicitação. Tente novamente.';
  }
  
  return message;
};

